import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import Routes from "./Components/Routes";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { Provider } from "react-redux";
import store from "./Store";
import { SocketContext,socketInstance } from "./Helper/Socket";
import Notiflix from "notiflix";
Notiflix.Loading.init({
  svgColor: "#c16d18", // Set your custom loader color here
  zIndex: 1500,
});



const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SocketContext.Provider value={socketInstance}>
      <Provider store={store}>
        <Routes />
      </Provider>
    </SocketContext.Provider>
  </React.StrictMode>
);
